import * as React from "react";
import * as ReactDOM from "react-dom";
import {IVoiceOverProps, VoiceOver} from "../../VoiceOver";

interface Props
{
    type?: string;
    onClick: () => void;
    children?: any;
}

import './Button.scss';

export default class Button extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    getIcon = () =>
    {
        const {type} = this.props;

        switch (type)
        {
            case 'show-leaderboard':

                return <i className="fas fa-trophy" />;

            case 'play-game':
            case 'play-again':

                return <i className="fas fa-play" />;

            case 'skip-year':

                return <i className="fas fa-fast-forward" />;

            case 'show-how-to-play':

                return <i className="fas fa-gamepad" />;

            case 'file-download':

                return <i className="fas fa-download"/>;

            case 'slideshow-cancel':

                return <i className="fas fa-arrow-left" />;

            case 'slideshow-previous':

                return <i className="fas fa-chevron-left" />;

            case 'slideshow-next':

                return <i className="fas fa-chevron-right" />;

            case 'slideshow-skip':

                return <i className="fas fa-fast-forward" />;

            case 'ok':

                return <i className="fas fa-check" />;

            case 'close':

                return <i className="fas fa-times" />;

            case 'remove-power-source':

                return <i className="fas fa-trash-alt" />;

            // case 'right-answer':
            //
            //     return <i className="fas fa-wrench" />;

            case 'wrong-answer':

                return <i className="fas fa-times" />;

            case 'main-menu':

                return <i className="fas fa-chevron-left" />;

            case 'more-info':

                return <i className="fas fa-trophy" />;

            // case 'quit-game':
            //
            //     return <i className="fas fa-sign-out-alt" />;

            default:

                return null;
        }
    };


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {type, onClick, children} = this.props;
        const style_name: string = type ? type : 'basic';

        return <button
                    styleName={style_name}
                    onClick={onClick}>
            {!! this.getIcon() &&
            <span styleName={children ? 'padded-icon' : 'icon'}>{this.getIcon()}</span>}

            {children}

        </button>
    }
}



// WEBPACK FOOTER //
// ./src/ts/app/common/ui/button/Button.tsx